import { FC, MouseEventHandler } from 'react';
import Link from 'next/link';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import Text from '@deprecated-ui/common/Text';
import { useRouter } from 'next/router';
import { sanitizeURL } from 'utils/general';
import useSecuritiesButton from 'features/securities/hooks/useSecuritiesButton';
import { TradingMenuItemContainer } from './styled';

interface TradingMenuItemProps {
  iconmoon: string;
  label: string;
  link: string;
}

const TradingMenuItem: FC<TradingMenuItemProps> = ({
  iconmoon,
  children,
  label,
  link,
}) => {
  const router = useRouter();

  const { handleLogoutTrading, handleClickSupportButton } =
    useSecuritiesButton();

  const handleNavigation: MouseEventHandler<HTMLAnchorElement> = async (e) => {
    if (!link) e.preventDefault();

    if (label === 'Trading Logout') {
      handleLogoutTrading();
      return;
    }

    if (label === 'Live Support') {
      handleClickSupportButton();
      return;
    }
    router.push(sanitizeURL(link));
  };

  return (
    <Link href={link} passHref>
      <TradingMenuItemContainer
        data-cy="trading-menu-item"
        onClick={handleNavigation}
      >
        <IconWrapper size="14px">
          <Iconmoon size="12px" className={iconmoon} />
        </IconWrapper>
        <Text size="14px" height="28px" padding="0 8px">
          {children}
        </Text>
      </TradingMenuItemContainer>
    </Link>
  );
};

export default TradingMenuItem;
